import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { cloneDeep } from 'lodash';
import { RappiderListGridModule } from '../list-grid/list-grid.module';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { Router } from '@angular/router';
import { ActionResponse } from '../../utils/action-utils';
import { DATA_FIELD_SIMPLE_DISPLAY_LIST_CONFIG } from './data-model-display-with-fields.config';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from "ng-zorro-antd/tooltip";


@Component({
  selector: 'rappider-data-model-display-with-fields',
  standalone: true,
  imports: [
    CommonModule,
    RappiderListGridModule,
    NzSkeletonModule,
    NzButtonModule,
    NzToolTipModule
],
  templateUrl: './data-model-display-with-fields.component.html',
  styleUrls: ['./data-model-display-with-fields.component.scss']
})
export class DataModelDisplayWithFieldsComponent implements OnInit {

  @Input() projectModel: any | undefined;
  @Input() animateTable = false;
  @Input() enableRowPointer = false;

  @Output() rowActionClick = new EventEmitter<ActionResponse>();
  @Output() deleteDataFieldClick = new EventEmitter<any>();

  DATA_FIELD_SIMPLE_DISPLAY_LIST_CONFIG = cloneDeep(DATA_FIELD_SIMPLE_DISPLAY_LIST_CONFIG);

  constructor(private router: Router) { }

  ngOnInit(): void {
    console.log('Component initialized.');
  }

  onDeleteDataFieldClick(field: any) {
    this.deleteDataFieldClick.emit(field?.data ?? field);
  }

  navigateToEditPage() {
    if (this.projectModel) {
      const basePath = 'projects/model-data-field-list/';
      this.router.navigate([basePath,this.projectModel.id], { queryParams: { tab: 'fields' } });
    }
  }

  onListActionClick(action: any) {
    console.log('List action clicked', action);
  }

  onDataFieldListActionDropdownItemClick(action: any) {
    console.log('Data field list action dropdown item clicked', action);
  }

  onOrderChange(event: any) {
    console.log('Order changed', event);
  }

  onRowActionClick(data: ActionResponse) {
    this.rowActionClick.emit(data);
  }


}
